import React, { useState, useRef, useEffect } from "react";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";

/**
 * 
 * @param title a string with the header content
 * @param message a string with a message content 
 * @param offsetTop a value in px to align the icon from the top: optional 
 * @returns an info icon with a popover window on hover
 */
const InfoPopover = ({title, message, offsetTop=-3}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [uniqueId, setUniqueId] = useState(null);
  const hideTimeout = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current); // cancel any pending hide
    setPopoverOpen(true);
  };

  const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => {
      setPopoverOpen(false);
    }, 100); // delay hiding to prevent flashing
  };

  useEffect(() => {
    setUniqueId(`info_popover_${Date.now()}-${Math.floor(Math.random() * 1000)}`);
  }, [])

  if(!uniqueId) {
    return "";
  }

  return (
    <span className="info-popover-wrapper" 
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} 
      style={{'top': offsetTop}}
    >
      <i id={uniqueId} className="popover-info bi bi-info-circle-fill" />
      <Popover 
        trigger="legacy"
        target={uniqueId}
        isOpen={popoverOpen}
      >
        <PopoverHeader>
          {title}
        </PopoverHeader>
        <PopoverBody
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div dangerouslySetInnerHTML={{__html: message}} />
        </PopoverBody>
      </Popover>
    </span>
  );
};

export default InfoPopover;
